import { render, staticRenderFns } from "./FieldsetContractValidityData.yaml?vue&type=template&id=27523bb0&component"
import script from "./FieldsetContractValidityData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractValidityData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports